import { kDITOWUtilsWrapper } from 'app-core/src/constants/injectionTokens';
import { IOWUtilsWrapper } from 'app-core/src/interfaces/ow-wrappers/ow-utils-wrapper.interface';
import { inject, singleton } from 'tsyringe';

// -----------------------------------------------------------------------------
// This class is used for different patches we have - it allows creating ugly
// hacks etc... in a single place so that they don't clutter the code.
// NOTE(twolf): We require resolving this class on startup.
@singleton()
export class PatchesService {
  // ---------------------------------------------------------------------------
  public constructor(
    @inject(kDITOWUtilsWrapper)
    private readonly owUtilsWrapper: IOWUtilsWrapper,
  ) {
    this.owUtilsWrapper.setClientStartupTime();
  }
}
